import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { Loader, Alert } from '../common';

export const TokenVerificationHandler: React.FC = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const { verifyToken } = useAuth();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    // Variable pour suivre si le composant est monté
    let isMounted = true;
    
    const verifyAuthToken = async () => {
      if (!token) {
        if (isMounted) {
          setError('Token manquant dans l\'URL');
          setIsLoading(false);
        }
        return;
      }

      try {
        if (isMounted) {
          setIsLoading(true);
        }
        const response = await verifyToken(token);
        
        if (isMounted) {
          if (response.status === 'success' && response.data) {
            // Redirection vers la page d'accueil après authentification réussie
            navigate('/', { replace: true });
          } else {
            setError('Le token est invalide ou a expiré');
            setIsLoading(false);
          }
        }
      } catch (error) {
        if (isMounted) {
          if (error instanceof Error) {
            setError(error.message);
          } else {
            setError('Une erreur est survenue lors de la vérification du token');
          }
          setIsLoading(false);
        }
      }
    };

    verifyAuthToken();
    
    // Fonction de nettoyage pour éviter les mises à jour sur un composant démonté
    return () => {
      isMounted = false;
    };
  }, [token, navigate]); // Retiré verifyToken des dépendances

  if (isLoading) {
    return (
      <div className="flex justify-center items-center min-h-screen">
        <Loader size="large" color="primary" text="Vérification de votre authentification..." />
      </div>
    );
  }

  if (error) {
    return (
      <div className="max-w-md mx-auto mt-8 p-4">
        <Alert 
          type="error" 
          title="Erreur d'authentification" 
          message={error}
        />
        <div className="mt-4 text-center">
          <button
            onClick={() => navigate('/auth', { replace: true })}
            className="bg-primary text-tertiary px-4 py-2 rounded hover:bg-yellow-500 transition-colors"
          >
            Retour à la page de connexion
          </button>
        </div>
      </div>
    );
  }

  return null;
};
